<template>
    <desc-node v-if="isNodeEdit" />
    <desc-list v-else v-model="form" @input="emit" />
</template>

<script>
import { mapState } from "vuex";
import { initEmploymentForm } from "@/assets/variables";

import DescNode from "./desc/desc-node.vue";
import DescList from "./desc/desc-list.vue";

export default {
    components: {
        DescNode,
        DescList,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
    }),
    computed: {
        ...mapState("employment/form/node", { isNodeEdit: "isEdit" }),
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
